import { Component, OnInit } from '@angular/core';
import { UpdatePasswordComponent } from "../../account-centre/update-password/update-password.component";
import { UpdateBasicInfoComponent } from "../../account-centre/update-basic-info/update-basic-info.component";
import { UpdatePhotosComponent } from "../../account-centre/update-photos/update-photos.component";
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
// import { UpdatePasswordComponent } from "../../account-centre/update-password/update-password.component";
// import { UpdateBasicInfoComponent } from "../../account-centre/update-basic-info/update-basic-info.component";
// import { UpdatePhotosComponent } from "../../account-centre/update-photos/update-photos.component";
import { UserSelectors } from '../../states/user/user-selector';
import { UserStateModel } from '../../states/user/user-state-model';
import { PortalService } from '../../services/account/portal.service';
import { Observable } from 'rxjs';
import { AccountCentrePromoCardComponent } from '../account-centre/components/account-centre-promo-card/account-centre-promo-card.component';
import { PersonalInfoCardComponent } from '../account-centre/components/personal-info-card/personal-info-card.component';
import { ParentDetailsCardComponent } from '../account-centre/components/parent-details-card/parent-details-card.component';
import { PasswordSecurityCardComponent } from '../account-centre/components/password-security-card/password-security-card.component';
import { ProfilePhotoCardComponent } from '../account-centre/components/profile-photo-card/profile-photo-card.component';
enum tabs {
  password = 'password',
  basicInfo = 'basicInfo',
  photos = 'photos'
}

@Component({
  selector: 'app-account-centre',
  standalone: true,
  imports: [
    AccountCentrePromoCardComponent,
    PersonalInfoCardComponent,
    ParentDetailsCardComponent,
    PasswordSecurityCardComponent,
    ProfilePhotoCardComponent,
    CommonModule,
    ReactiveFormsModule,
    UpdatePasswordComponent,
    UpdateBasicInfoComponent,
    UpdatePhotosComponent
  ],
  templateUrl: './account-centre.component.html',
  styleUrl: './account-centre.component.scss'
})
export class AccountCentreComponent implements OnInit {
  constructor(private store: Store, private portalService: PortalService) { }

  user!: UserStateModel;
  selectedTab: tabs = tabs.basicInfo;
  tabs = tabs;
  currentPortal: string | null = null;
  currentPortal$: Observable<string | null> = this.portalService.currentPortal$;
 studentPortal: boolean = false;
  setSelectedTab(tab: tabs) {
    this.selectedTab = tab;
  }

  ngOnInit(): void {
    this.getUser();
    this.portalService.currentPortal$.subscribe(portal => {
      if (portal !== null) {
        this.currentPortal = portal;
       this.studentPortal = true; 
      }
    });
  }

  getUser() {
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.user = response;
      },
      error: (error) => {
        console.warn('Error fetching user:', error);
      }
    });
  }
}
